import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Trans } from '@lingui/macro'
import { Button } from 'components/UI/Button/Button'
import { SelectBox, typeValuesListItem } from 'components/UI/SelectBox/SelectBox'
import { getCategoriesList } from 'model/dashboardCategories/dCategoriesAPI'
import { logoutSagaAC } from 'model/system/systemActionCreators'
import { IdProductsState } from 'model/dashboardProducts/dProductsReducer'
import { dProductsBulkPatchSagaAC } from 'model/dashboardProducts/dProductsActionCreators'


// Type
export type typePopupBulkChangeCategory = {
    variant?: string
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
}

export type typeBulkChangeCategoryObject = {
    id: string,
    category: {
        id: string | number | null
    } | null
}


// Component
export const PopupBulkChangeCategory: React.FC<typePopupBulkChangeCategory> = ({ variant, setOpenPopup }) => {

    const dispatch = useDispatch()

    const filters = useSelector((state: { dProducts: IdProductsState }) => state.dProducts.filters)
    const pagination = useSelector((state: { dProducts: IdProductsState }) => state.dProducts.pagination)

    useEffect(() => {
        const setData = async () => {
            const responseCategories = await getCategoriesList({})
            if (responseCategories.status === 200) {
                const newCategoriesList = [ ...selectCategoryList, ...responseCategories.data ]
                setSelectCategoryList(newCategoriesList)
            } else if (responseCategories.status === 401) {
                dispatch(logoutSagaAC())
            }

        }
        setData()
        // eslint-disable-next-line
    }, [])

    const [ categoryIdValue, setCategoryIdValue ] = useState<string | number | null>(null)
    const [ selectCategoryList, setSelectCategoryList ] = useState<typeValuesListItem[]>([])

    const checkedList = useSelector((state: { dProducts: IdProductsState }) => state.dProducts.data)

    const onAddHandler = (e: React.FormEvent) => {
        e.preventDefault()
        const dataBulkObjectList: typeBulkChangeCategoryObject[] = checkedList
            .filter(item => item.checked === true)
            .map(item => ( {
                id: item.id,
                category: ( categoryIdValue ? { id: categoryIdValue } : null )
            } ))
        dispatch(dProductsBulkPatchSagaAC(dataBulkObjectList, filters, {
            page: pagination.pageNumber,
            size: pagination.itemsPerPage!
        }))
        setOpenPopup(false)
    }

    return (
        <form onSubmit={ (e) => onAddHandler(e) }>

            <div>
                <SelectBox
                    variant={ variant }
                    label={ <Trans>Category</Trans> }
                    valuesList={ selectCategoryList }
                    valueId={ categoryIdValue }
                    setIdValue={ setCategoryIdValue }
                    labelClassname="text-left"
                    selectBosClassname="sm:w-80"
                />
            </div>

            <div className="flex gap-4 mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <Button type="submit" variant={ variant } label={ <Trans>Change category</Trans> }/>
                <Button type="button" secondary={ true } label={ <Trans>Close</Trans> }
                        onClick={ () => setOpenPopup(false) }/>
            </div>

        </form>
    )
}
